/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({

  storesearch: {
    name: 'storesearch',
    componentName: 'SearchContainer',
    chunk: () => import(
      /* webpackChunkName: "storesearch" */
      './pages/store-search/SearchContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-search/SearchContainer.js')).SearchContainer
        : currentRouteName === 'storesearch'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SearchContainer })))
    },
    path: '/:context?/l/search/:storeNumber',
    varnish: false,
    channel: null
  },
  storedetails: {
    name: 'storedetails',
    componentName: 'DetailsContainer',
    chunk: () => import(
      /* webpackChunkName: "storedetails" */
      './pages/store-details/DetailsContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-details/DetailsContainer.js')).DetailsContainer
        : currentRouteName === 'storedetails'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.DetailsContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber',
    varnish: true,
    channel: null
  },
  storedirectory: {
    name: 'storedirectory',
    componentName: 'DirectoryContainer',
    chunk: () => import(
      /* webpackChunkName: "storedirectory" */
      './pages/store-directory/DirectoryContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-directory/DirectoryContainer.js')).DirectoryContainer
        : currentRouteName === 'storedirectory'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.DirectoryContainer })))
    },
    path: '/:context?/l/storeDirectory',
    varnish: true,
    channel: null
  },
  statedirectory: {
    name: 'statedirectory',
    componentName: 'StateDirectoryContainer',
    chunk: () => import(
      /* webpackChunkName: "statedirectory" */
      './pages/store-directory/StateDirectoryContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-directory/StateDirectoryContainer.js')).StateDirectoryContainer
        : currentRouteName === 'statedirectory'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StateDirectoryContainer })))
    },
    path: '/:context?/l/:state',
    varnish: true,
    channel: null
  },

  homeServices: {
    name: 'homeservices',
    componentName: 'HomeServicesContainer',
    chunk: () => import(
      /* webpackChunkName: "homeservices" */
      './pages/home-services/HomeServicesContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/home-services/HomeServicesContainer.js')).HomeServicesContainer
        : currentRouteName === 'homeservices'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.HomeServicesContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/services',
    varnish: true,
    channel: null
  },

  rentalServices: {
    name: 'rentalservices',
    componentName: 'RentalServicesContainer',
    chunk: () => import(
      /* webpackChunkName: "rentalservices" */
      './pages/rental-services/RentalServicesContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/rental-services/RentalServicesContainer.js')).RentalServicesContainer
        : currentRouteName === 'rentalservices'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.RentalServicesContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/rentals',
    varnish: true,
    channel: null
  },

  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/Home'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })))
    },
    path: '/:context?/l/',
    channel: null
  }
});
